var map = {
	"./about-us-banner-cn.webp": 1552,
	"./about-us-banner-m-cn.webp": 1553,
	"./about-us-banner-m-ms.webp": 1554,
	"./about-us-banner-m.webp": 1555,
	"./about-us-banner-ms.webp": 1556,
	"./about-us-banner.webp": 468,
	"./banner-01.jpg": 1557,
	"./banner-slot.jpg": 1558,
	"./bet-and-earn-banner-cn.webp": 1559,
	"./bet-and-earn-banner-indon.webp": 1560,
	"./bet-and-earn-banner-ms.webp": 1561,
	"./bet-and-earn-banner.webp": 1562,
	"./check-in-banner-cn.webp": 1563,
	"./check-in-banner-id.webp": 1564,
	"./check-in-banner-ms.webp": 1565,
	"./check-in-banner.webp": 1566,
	"./cny_2024-bm.webp": 1567,
	"./cny_2024-cn.webp": 1568,
	"./cny_2024.webp": 1569,
	"./epl-banner-cn.webp": 1570,
	"./epl-banner-indo.webp": 1571,
	"./epl-banner-ms.webp": 1572,
	"./epl-banner.webp": 1573,
	"./games-banners-cn.webp": 1574,
	"./games-banners-ms.webp": 1575,
	"./games-banners.webp": 1576,
	"./lb-m-banner-cn.webp": 1577,
	"./lb-m-banner.webp": 1578,
	"./leaderboard-banner-cn.webp": 1579,
	"./leaderboard-banner.webp": 1580,
	"./lottery-banner.webp": 1581,
	"./lottery-banners-cn.webp": 1582,
	"./lottery-banners-ms.webp": 1583,
	"./lottery-banners.webp": 1584,
	"./lucky-spin-banner-cn.webp": 1585,
	"./lucky-spin-banner-ms.webp": 1586,
	"./lucky-spin-banner.webp": 1587,
	"./p2p-banner.webp": 1588,
	"./p2p-banners-cn.webp": 1589,
	"./p2p-banners-ms.webp": 1590,
	"./p2p-banners.webp": 1591,
	"./premier-league-banner-cn.webp": 1592,
	"./premier-league-banner.webp": 1593,
	"./promo-vip-banner-cn.webp": 1594,
	"./promo-vip-banner-ms.webp": 1595,
	"./promo-vip-banner.webp": 1596,
	"./promos-banner-cn.webp": 1597,
	"./promos-banner-indon.webp": 1598,
	"./promos-banner-ms.webp": 1599,
	"./promos-banner.webp": 1600,
	"./promos-detail-banner.jpg": 1601,
	"./side-bar-banner.jpg": 1602,
	"./slot-banners-cn.webp": 1603,
	"./slot-banners-ms.webp": 1604,
	"./slot-banners.webp": 1605,
	"./speed-banners-cn.webp": 1606,
	"./speed-banners-ms.webp": 1607,
	"./speed-banners.webp": 1608,
	"./vip-banner-cn.webp": 1609,
	"./vip-banner-id.webp": 1610,
	"./vip-banner-m-cn.webp": 1611,
	"./vip-banner-m-ms.webp": 1612,
	"./vip-banner-m.webp": 1613,
	"./vip-banner-ms.webp": 1614,
	"./vip-banner.webp": 1615,
	"./vip-deposit-marathon-challenges-cn.webp": 1616,
	"./vip-deposit-marathon-challenges-ms.webp": 1617,
	"./vip-deposit-marathon-challenges.webp": 1618,
	"./winner-leaderboard-banner-cn.webp": 1619,
	"./winner-leaderboard-banner.webp": 1620,
	"./world-cup-banner-cn.webp": 1621,
	"./world-cup-banner.webp": 1622,
	"./world-cup-two-banner-cn.webp": 1623,
	"./world-cup-two-banner.webp": 1624
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 49;